import {RefObject, useEffect, useRef} from "react";


type Handlers = {
  onExternalClick: (e: MouseEvent) => void
    onInternalClick: (e: MouseEvent) => void
}

export const useOutsideClick = <T extends HTMLElement>(ref: RefObject<T>, {onExternalClick, onInternalClick}: Handlers) => {
  const handlerRef = useRef<any>(null)
  const handleClick = (e: any) => {
    if (!ref.current) {
      return
    }
    const isInternal = ref.current.contains(e.target as Element)
    isInternal
      ? onInternalClick?.(e)
      : onExternalClick?.(e)
  }
  handlerRef.current = handleClick
  useEffect(() => {
    const onClick = (e: MouseEvent) => handlerRef.current?.(e)

    document.addEventListener('click', onClick);

    return () => {
      document.removeEventListener('click', onClick);
    }
  }, [])
}
